import React, { useState } from 'react';

import PokemonItems from '../../components/PokemonItems/PokemonItems.jsx';
// import Auxiliary from '../../hoc/AuxComponent/AuxComponent';

import { useQuery } from '@apollo/client';
import { GET_POKEMONS } from '../../components/graphql/get-pokemons';

import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';

import EcommerceAds from '../../components/EcommerceAds/EcommerceAds';
import InfiniteScroll from 'react-infinite-scroll-component';

function PokemonList(props) {

    const { loading, error, fetchMore, data } = useQuery(GET_POKEMONS, {
        variables: { limit: 30, offset: 0 },
        onCompleted: () => {
            setPokemonListState(
                {

                    "next": data.pokemons.next,
                    "previous": data.pokemons.previous,
                    "nextOffset": data.pokemons.nextOffset,
                    "previousOffset": data.pokemons.previousOffset,
                    "pokemonList": [
                        ...data.pokemons.results.map((item) => {
                            return {
                                ...item,
                                numberOwned: props.mySavedData.pokemonList.filter((savedPokemonItem) => savedPokemonItem.name === item.name).length
                            }
                        })
                    ]
                }
            );
        }
    })


    const [pokemonListState, setPokemonListState] = useState(
        {
            "next": null,
            "previous": null,
            "nextOffset": null,
            "previousOffset": null,
            "pokemonList": []
        }
    );


    const fetchMorePokemon = () => {
        fetchMore({
            variables: { limit: 30, offset: pokemonListState.nextOffset },
            updateQuery: (prevResult, { fetchMoreResult }) => {
                setPokemonListState(
                    {

                        "next": fetchMoreResult.pokemons.next,
                        "previous": fetchMoreResult.pokemons.previous,
                        "nextOffset": fetchMoreResult.pokemons.nextOffset,
                        "previousOffset": fetchMoreResult.pokemons.previousOffset,
                        "pokemonList": [
                            ...pokemonListState.pokemonList,
                            ...fetchMoreResult.pokemons.results.map((item) => {
                                return {
                                    ...item,
                                    numberOwned: props.mySavedData.pokemonList.filter((savedPokemonItem) => savedPokemonItem.name === item.name).length
                                }
                            })
                        ]
                    }
                );
            }
        });

    };



    if (error) return;

    return (

        <div>

            { loading ? <LoadingSpinner />
                : error ? <p>Error... Something went wrong with the GraphQL connection...</p>
                    : <div>
                        <h1>Pokemon list:</h1>

                        <InfiniteScroll
                            dataLength={pokemonListState.pokemonList.length}
                            next={() => { fetchMorePokemon() }}
                            hasMore={true}
                            loader={<LoadingSpinner />}>
                            <PokemonItems pokemonList={pokemonListState} mySavedData={props.mySavedData} />
                        </InfiniteScroll>

                        <EcommerceAds name="Pokemon" />
                    </div>
            }
        </div>

    )
}

export default PokemonList;
